import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@context/AuthContext";
import { BookSessionContext } from "@context/BookSessionContext";

export function useLoginForm({ onSubmit, clearOnMount = true }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const {
        loginError,
        successMessage,
        setSuccessMessage,
        setTempAccountLogin,
        clearLoginError,
    } = useContext(AuthContext);
    const { setIsTempAccount } = useContext(BookSessionContext);

    const clearMessages = () => {
        clearLoginError();
        setSuccessMessage(null);
    };

    useEffect(() => {
        if (!clearOnMount) return undefined;
        clearMessages();
        return clearMessages;
    }, []);

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        clearLoginError();
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        clearLoginError();
    };

    const handleSubmit = (evt, extraFields = {}) => {
        evt.preventDefault();
        clearLoginError();
        setIsTempAccount(false);
        setTempAccountLogin(true);
        onSubmit({ username, password, ...extraFields });
    };

    const showError = !!(loginError && username !== "" && password !== "");

    return {
        username,
        password,
        handleUsernameChange,
        handlePasswordChange,
        handleSubmit,
        showError,
        loginError,
        successMessage,
    };
}
